import { applyMiddleware, legacy_createStore as createStore } from 'redux'
import { composeWithDevToolsDevelopmentOnly as composeWithDevTools } from '@redux-devtools/extension'
import thunk from 'redux-thunk'
import { rootReducer } from './reducer'

export const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
)
